import { encode as base64_encode } from 'base-64';
import { postApi, baseURL } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';
import config from "../config";
import { getCached, setCached } from './cacheStore';

class FleetSummaryReportStore {
  fleetSummaryReport = []
  loading = false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      fleetSummaryReport: observable,
      loading: observable,
      // total : action,
      loadData: action,


    });
    this.rootStore = rootStore;

  }



  async loadData({ companyId, offset, limit, vehicleId, fromDate, toDate, speed, distance, allVehicleIds }) {
    const cacheKey = `fleetsummaryreportlist:${companyId}:${vehicleId}:${allVehicleIds}:${fromDate}:${toDate}:${speed}:${distance}:${offset}:${limit}`;
    const cached = getCached(cacheKey);
    if (cached) {
      this.total = cached.total;
      this.fleetSummaryReport = cached.reportData;
      return;
    }
    this.loading = true;
    var response
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "fromDate": fromDate, "toDate": toDate, "distanceInt": distance, speed: speed, "offset": offset, "limit": limit, "page": 1, }
    if (config.pythonReport == 1) {
      response = await postApi.getClient('report').post("fleet_report/fleetSummary", postData);
    }
    else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=vehicle&a=fleetsummary", "postData=" + base64Input);
    }

    const reportData = response?.data?.data?.fleetsummary ?? []
    const total = parseInt(response?.data?.data?.TotalCount)
    setCached(cacheKey, { total, reportData });

    this.total = total
    this.fleetSummaryReport = reportData
    this.loading = false;
    // this.total = parseInt(response?.data?.data?.TotalCount)
    // this.fleetSummaryReport = response?.data?.data?.fleetsummary
    // this.loading = false;

  }


  async exportExcel(getData) {

    if (config.pythonReport === 1) {



      try {
        await postApi.getClient("report").post("/fleet_report/fleetSummary/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }

    } else {

      // console.log("getData", getData);
      let lang = "english";
      let distanceInt = 0
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportfleetsummaryexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        // "&int="+
        // getData.interval+
        "&fD=" +
        getData.fromDate +
        "&distanceInt=" +
        distanceInt +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;

    }

  }

  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      try {
        await postApi.getClient("report").post("/fleet_report/fleetSummary/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportfleetsummarypdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        // "&int="+
        // getData.interval+
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportfleetsummarycsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportdaysummaryxml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&vid=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }

}

export default FleetSummaryReportStore;
